const currencyCodes = ['AUD', 'EUR', 'GBP', 'USD'] as const;

export type CurrencyCode = (typeof currencyCodes)[number];

// Widened so it can check an unvalidated string such as a cookie or query param.
export const validCurrencies: readonly string[] = currencyCodes;
